import _ from 'lodash';
import * as moment from 'moment';
import { Action, createReducer, on } from '@ngrx/store';
import * as ChatActions from './chat.actions';
import { WEBSOCKET_VIRTUAL_EVENT_COMMAND } from 'app/virtual-event/virtual-event.enums';

export const chatFeatureKey = 'chat';

export interface State {
  status: string;
  messages: any[];
}

export const initialState: State = {
  status: 'closed',
  messages: []
};

export const reducer = createReducer(
  initialState,

  on(ChatActions.loadChats, state => state),

  on(ChatActions.UpdateChatStatus, (state, { status }) => {
    return { ...state, status };
  }),

  on(ChatActions.SendChatMessageSuccess, (state) => {
    return { ...state };
  }),

  on(ChatActions.AddChatMessage, (state, { payload }) => {
    const start = Math.max(state.messages.length - 100, 0);
    const messages = _.chain([
      ...state.messages,
      { ...payload, deleted: false, blocked: _.isEqual(payload.messageStatus, 1) }
    ]).slice(start).value();
    return { ...state, messages };
  }),

  on(ChatActions.DeleteChatMessage, (state, { payload } ) => {
    const { donor } = _.find(state.messages, (message) => {
      if(message.messageId === payload.id) return true;
    });
    return {
      ...state,
      messages: _.map(state.messages, (message) => {
        let blocked = message.blocked;
        if(payload.blockUser) {
          blocked = message.donor.id === donor.id ? true: blocked;
        }
        return { ...message, blocked };
      })
    };
  }),

  on(ChatActions.UnblockChatAttendee, (state, { payload } ) => {
    const { donor } = _.find(state.messages, (message) => {
      if(message.messageId === payload.id) return true;
    });
    return {
      ...state,
      messages: _.map(state.messages, (message) => {
        const blocked = message.donor.id === donor.id ? false: message.blocked;
        return { ...message, blocked };
      })
    };
  }),

  on(ChatActions.WSDeleteChatMessage, (state, { payload }) => {
    const messages = _.map(state.messages, (message) => {
      if(_.isEqual(payload, {
        action: WEBSOCKET_VIRTUAL_EVENT_COMMAND.DELETE_CHAT_ITEM,
        messageId: message.messageId,
        userId: message.donor.id
      })) {
        return { ...message, deleted: true };
      }
      return { ...message };
    });
    return {
      ...state,
      messages: [...messages]
    };
  }),

);

